module.exports = __webpack_public_path__ + "img/firefox.f69e36bc.png";